import { resolveUnitId } from '#/modules/imsMgmt/helper/materialUnit/resolveUnitId';

const EMPTY_INBOUND_PACKAGE = {
  qty: '',
  locationId: '',
};

/**
 * IMS 入庫詳情 → 工單入庫表單。
 * 成品取第一筆 line；物料備註用 line.remark，單據備註用 header remark。
 */
export function mapStockReceiptDetailToInboundForm(receipt) {
  const line = receipt?.lines?.[0] ?? null;
  const packages = (line?.packages ?? []).map((pkg) => ({
    qty: pkg?.qty ?? pkg?.quantity ?? '',
    locationId: pkg?.locationId ?? pkg?.location?.id ?? '',
  }));

  return {
    receiptDate: receipt?.receiptDate ?? '',
    warehouseId: receipt?.warehouse?.id ?? receipt?.warehouseId ?? '',
    unitId: resolveUnitId(line?.unit) || String(line?.unitId ?? '').trim(),
    unitPrice: line?.unitPrice ?? '',
    materialRemark: line?.remark ?? '',
    remark: receipt?.remark ?? '',
    issueReason: receipt?.issueReason ?? '',
    packages: packages.length ? packages : [{ ...EMPTY_INBOUND_PACKAGE }],
  };
}

/**
 * 入庫表單 → create／update payload（camel；再交 API serialize／keysToSnake）。
 * `materialRemark` 無獨立 API 欄：併入 header `remark`。
 * line 級 `unitId`；packages 不帶 unitId（繼承 line）。不送來源、供應商。
 */
export function mapInboundFormToCreatePayload(values, detail) {
  const remarkParts = [values?.remark, values?.materialRemark]
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter(Boolean);

  return {
    receiptDate: values?.receiptDate,
    warehouseId: values?.warehouseId,
    remark: remarkParts.length ? remarkParts.join('\n') : null,
    issueReason: values?.issueReason || null,
    lines: [{
      mtrId: detail?.mtr?.id ?? detail?.mtrId,
      unitId: values?.unitId,
      unitPrice: values?.unitPrice === '' || values?.unitPrice == null
        ? 0
        : Number(values.unitPrice),
      packages: (values?.packages ?? []).map((pkg) => ({
        locationId: pkg?.locationId || null,
        qty: pkg?.qty === '' || pkg?.qty == null ? null : Number(pkg.qty),
      })),
    }],
  };
}
